module.exports = __webpack_public_path__ + "img/glossary-icon-orange.eef22333.svg";